import { useContext } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Head from 'next/head';
import Form from '../components/Form/Form';
import { FormContext } from '../context/FormContext';
import { dig } from '../helpers/dig';
import { EMAIL_REGEX } from '../components/Form/helpers';
import contentfulClient from '../client/contentful';

const RequestInvite = () => {
  const formState = useContext(FormContext);
  return (
    <>
      <Head>
        <title>Signup - Mutiny | Turn Your Website Into Your #1 Growth Channel</title>
      </Head>
      <Formik
        validationSchema={Yup.object().shape({
          email: Yup.string().required().matches(EMAIL_REGEX),
          domain: Yup.string().required(),
          useCase: Yup.string().required(),
          monthlyVisitors: Yup.string().required(),
        })}
        initialValues={{
          email: formState.preEnteredEmail || '',
          domain: formState.latestEnrichResult ? dig(formState.latestEnrichResult, 'company', 'domain') : '',
          useCase: '',
          monthlyVisitors: '',
        }}
        render={(props) => <Form {...props} />}
      />
    </>
  );
};

export async function getStaticProps() {
  let data = {};

  const client = contentfulClient;

  await client
    .getEntries({
      content_type: 'signupForm',
    })
    .then((entries) => {
      data = entries.items[0];
    });
  // TODO: bugsnag
  // .catch(console.error);
  return {
    props: {
      thankYouSlug: data.fields.thankYouCaseStudy.fields.slug,
    },
  };
}

export default RequestInvite;
